import React from 'react';
import PropTypes from 'prop-types';

import ChatMessage from '../../../../Model/ChatMessage';
import { formatTimeForChatMessage } from '../../../../utils/time';

import {
  Container,
  Pill,
  Row,
  TitleText,
  DescriptionText,
  TimeText,
} from './styles';

const SystemMessagePreview = ({ message }) => {
  const { systemMessage, text, createdAt } = message;

  const displayText = systemMessage?.description ?? text;

  return (
    <Container>
      <Pill>
        <Row>
          {!!systemMessage?.title && (
            <TitleText>{systemMessage.title}</TitleText>
          )}
          {!!displayText && (
            <DescriptionText>{displayText}</DescriptionText>
          )}
        </Row>
        <TimeText>{formatTimeForChatMessage(createdAt)}</TimeText>
      </Pill>
    </Container>
  );
};

SystemMessagePreview.propTypes = {
  message: PropTypes.instanceOf(ChatMessage).isRequired,
};

export default SystemMessagePreview;
